function toFiniteNumber(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function validateLdsPaymentLinkAmount(
  amount,
  remainingBalance,
  { additionalPaymentMode = false } = {}
) {
  const parsedAmount = toFiniteNumber(amount);
  const parsedRemaining = toFiniteNumber(remainingBalance);

  if (parsedAmount == null || parsedAmount <= 0) {
    return {
      valid: false,
      error: "יש להזין סכום חיובי",
      normalizedAmount: null,
    };
  }

  if (
    !additionalPaymentMode &&
    parsedRemaining != null &&
    parsedRemaining > 0 &&
    parsedAmount > parsedRemaining
  ) {
    return {
      valid: false,
      error: "לא ניתן ליצור לינק בסכום גבוה מהיתרה לתשלום",
      normalizedAmount: parsedAmount,
    };
  }

  return {
    valid: true,
    error: null,
    normalizedAmount: parsedAmount,
  };
}

/**
 * Payment-agent LDS link. A single open card must charge the package payable.
 * Split cards may be lower, but never above the payable.
 */
export function validateLdsCheckoutPaymentAmount(
  amount,
  payableIls,
  { rejectedUnconvertedAmount = null } = {}
) {
  const parsedAmount = toFiniteNumber(amount);
  const payable = toFiniteNumber(payableIls);
  if (parsedAmount == null || parsedAmount <= 0) {
    return {
      valid: false,
      error: "יש להזין סכום חיובי",
      normalizedAmount: null,
    };
  }
  const normalizedAmount = Math.ceil(parsedAmount);
  if (payable == null || payable <= 0) {
    return {
      valid: false,
      error: "חסר מחיר חבילה לאימות קישור התשלום",
      normalizedAmount,
    };
  }
  const payableWhole = Math.ceil(payable);
  if (normalizedAmount > payableWhole) {
    return {
      valid: false,
      error: "לא ניתן ליצור לינק בסכום גבוה מהיתרה לתשלום",
      normalizedAmount,
    };
  }
  const rejected = toFiniteNumber(rejectedUnconvertedAmount);
  const rejectedWhole = rejected != null && rejected > 0 ? Math.ceil(rejected) : null;
  if (
    rejectedWhole != null &&
    rejectedWhole !== payableWhole &&
    normalizedAmount === rejectedWhole
  ) {
    return {
      valid: false,
      error: `סכום הקישור (₪${normalizedAmount.toLocaleString("he-IL")}) אינו תואם למחיר החבילה (₪${payableWhole.toLocaleString("he-IL")}). יצירת הקישור נחסמה.`,
      normalizedAmount,
    };
  }
  return { valid: true, error: null, normalizedAmount };
}

/**
 * Amount fields posted to /getLDSPaymentUrl.
 * Principal must be the ILS payable, a deposit, or a split share — never the
 * unconverted USD figure. Installment interest stays on `amount` only.
 */
export function buildLdsPaymentUrlAmounts({
  cardAmount,
  numberOfPayments = 1,
  amountWithInterest = null,
  payableIls,
  rejectedUnconvertedAmount = null,
} = {}) {
  const principal = toFiniteNumber(cardAmount);
  if (principal == null || principal <= 0) {
    return { ok: false, error: "יש להזין סכום חיובי", amount: null, actualAmount: null, currency: "ILS" };
  }
  const payments = Math.max(1, Math.floor(Number(numberOfPayments)) || 1);
  const actualAmount = Math.ceil(principal);
  const check = validateLdsCheckoutPaymentAmount(actualAmount, payableIls, {
    rejectedUnconvertedAmount,
  });
  if (!check.valid) {
    return {
      ok: false,
      error: check.error,
      amount: null,
      actualAmount,
      currency: "ILS",
    };
  }
  const interestAmount = toFiniteNumber(amountWithInterest);
  const amount =
    payments > 1 && interestAmount != null
      ? Number(interestAmount.toFixed(2))
      : actualAmount;
  return { ok: true, error: null, amount, actualAmount, currency: "ILS" };
}

export function validateLdsPaymentLinkNote(note, { required = false } = {}) {
  const text = String(note ?? "").trim();
  if (!required) {
    return { valid: true, error: null, normalizedNote: text || null };
  }
  if (text.length < 2) {
    return {
      valid: false,
      error: "חובה לציין הערה/סיבת תשלום",
      normalizedNote: null,
    };
  }
  return { valid: true, error: null, normalizedNote: text };
}

